export const uk = {
    'empty-gallery-message': 'Нічого не знайдено',
    'preview-error': 'При загрузке данных превью произошла ошибка. Попробуйте позже.',
    'remove-item-confirmation': 'Вы уверены, что хотите удалить файл «{name}»?'
};
